"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ColumnDelete_exports = {};
__export(ColumnDelete_exports, {
  default: () => ColumnDelete_default
});
module.exports = __toCommonJS(ColumnDelete_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.5 6.91016V17.75H4.66016V6.91016H5.5ZM16.6914 12.75C16.8216 12.75 16.9323 12.7956 17.0234 12.8867C17.1146 12.9779 17.1602 13.082 17.1602 13.1992V16.4609C17.1602 16.5911 17.1146 16.7018 17.0234 16.793C16.9323 16.8711 16.8216 16.9102 16.6914 16.9102H10.1289C9.9987 16.9102 9.88802 16.8711 9.79688 16.793C9.70573 16.7018 9.66016 16.5911 9.66016 16.4609V13.1992C9.66016 13.082 9.70573 12.9779 9.79688 12.8867C9.88802 12.7956 9.9987 12.75 10.1289 12.75H16.6914ZM16.2227 13.668H10.5977V16.0117H16.2227V13.668ZM16.6914 7.75C16.8216 7.75 16.9323 7.79557 17.0234 7.88672C17.1146 7.97786 17.1602 8.08203 17.1602 8.19922V11.4609C17.1602 11.5911 17.1146 11.7018 17.0234 11.793C16.9323 11.8711 16.8216 11.9102 16.6914 11.9102H10.1289C9.9987 11.9102 9.88802 11.8711 9.79688 11.793C9.70573 11.7018 9.66016 11.5911 9.66016 11.4609V8.19922C9.66016 8.08203 9.70573 7.97786 9.79688 7.88672C9.88802 7.79557 9.9987 7.75 10.1289 7.75H16.6914ZM16.2227 8.66797H10.5977V11.0117H16.2227V8.66797ZM5.96875 2.75C6.02083 2.75 6.06641 2.76302 6.10547 2.78906C6.15755 2.80208 6.19661 2.82161 6.22266 2.84766C6.26172 2.88672 6.28776 2.93229 6.30078 2.98438C6.32682 3.02344 6.33984 3.0625 6.33984 3.10156C6.33984 3.14062 6.33333 3.17969 6.32031 3.21875C6.30729 3.25781 6.29427 3.29036 6.28125 3.31641L6.22266 3.35547L5.59766 4L6.24219 4.64453L6.28125 4.70312C6.29427 4.72917 6.30729 4.76172 6.32031 4.80078C6.33333 4.82682 6.33984 4.85938 6.33984 4.89844C6.33984 4.9375 6.32682 4.98307 6.30078 5.03516C6.28776 5.07422 6.26823 5.10677 6.24219 5.13281C6.20312 5.17188 6.15755 5.20443 6.10547 5.23047C6.06641 5.24349 6.02083 5.25 5.96875 5.25C5.92969 5.25 5.89062 5.24349 5.85156 5.23047C5.82552 5.21745 5.79948 5.20443 5.77344 5.19141L5.71484 5.15234L5.08984 4.50781L4.42578 5.15234L4.38672 5.19141C4.36068 5.21745 4.32812 5.23698 4.28906 5.25C4.26302 5.25 4.23047 5.25 4.19141 5.25C4.13932 5.25 4.09375 5.24349 4.05469 5.23047C4.01562 5.20443 3.98307 5.17839 3.95703 5.15234C3.91797 5.11328 3.88542 5.07422 3.85938 5.03516C3.84635 4.98307 3.83984 4.9375 3.83984 4.89844C3.83984 4.85938 3.83984 4.82031 3.83984 4.78125C3.85286 4.74219 3.8724 4.70964 3.89844 4.68359L3.9375 4.64453L4.5625 4L3.91797 3.35547L3.87891 3.29688C3.86589 3.27083 3.85286 3.24479 3.83984 3.21875C3.83984 3.17969 3.83984 3.14062 3.83984 3.10156C3.83984 3.0625 3.84635 3.02344 3.85938 2.98438C3.8724 2.93229 3.89844 2.89323 3.9375 2.86719C3.96354 2.82812 3.99609 2.80208 4.03516 2.78906C4.08724 2.76302 4.13932 2.75 4.19141 2.75C4.23047 2.75 4.26302 2.75651 4.28906 2.76953C4.32812 2.78255 4.36068 2.79557 4.38672 2.80859L4.44531 2.84766L5.08984 3.49219L5.73438 2.84766L5.79297 2.80859C5.81901 2.78255 5.84505 2.76953 5.87109 2.76953C5.91016 2.75651 5.94271 2.75 5.96875 2.75Z",
      fill: "currentColor"
    }
  )
);
const SvgColumnDelete = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ColumnDelete_default = SvgColumnDelete;
